import { useQuery } from "@tanstack/react-query"
import { sdk } from "@/api/sdk"
import { type ShortUrlType } from "@/generated/graphql"

const getShortLinkQueryKey = ({ shortCode }: { shortCode: string }) => {
  return ["appShortLinkRedirect", shortCode]
}

export const useAppShortLinkRedirect = (shortCode: string) => {
  return useQuery({
    queryKey: getShortLinkQueryKey({ shortCode }),
    queryFn: async () => {
      try {
        const response = await sdk.ShortLinkRedirect({ shortCode })
        // console.log(
        //   "*** Getting shortLink query with:",
        //   JSON.stringify(response, null, 2),
        // )
        return response.appShortLinkRedirect as ShortUrlType
      } catch (err) {
        console.error(err)
        throw err
      }
    },
  })
}
